import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownSelectComponent } from './dropdown-select.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { ValidMsgModule } from '../valid-msg/valid-msg.module';

@NgModule({
    imports: [
        CommonModule,
        NgZorroAntdModule,
        ValidMsgModule
    ],
    declarations: [ DropdownSelectComponent ],
    exports: [ DropdownSelectComponent ]
})
export class DropdownSelectModule {}
